import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import Navbar from '../components/Navbar/Navbar';
import Dashboard from '../components/Dashboard/Dashboard';
import ConferenceRegistrationForm from '../components/ConferenceRegistrationForm/ConferenceRegistrationForm';
import FeePayment from '../components/FeePayment/FeePayment';
import AbstractSubmission from '../components/AbstractSubmission/AbstractSubmission';
import RegistrationInfo from '../components/RegistrationInfo/RegistrationInfo';
import { useQuery } from '@tanstack/react-query';
import VerifyPayment from '../components/VerifyPayment/VerifyPayment';

const ConferenceRegPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const {data: authUser} = useQuery({queryKey: ['authUser']})
  // Update the active menu based on the current path
  useEffect(() => {
    if (location.pathname.includes('dashboard')) {
      setActiveMenu('dashboard');
    } else if (location.pathname.includes('register')) {
      setActiveMenu('register');
    } else if (location.pathname.includes('abstract')) {
      setActiveMenu('abstract');
    }
    else if(location.pathname.includes('payment') || location.pathname.includes('info')) {
      setActiveMenu('payment')
    }
  }, [location]);

  return (
    <div className="h-screen flex flex-col">
      <Header />
      <Navbar />
      <div className="flex flex-col md:flex-row md:flex-1  overflow-hidden">
        {/* Sidebar */}
        <div className="flex flex-col gap-5 w-full md:w-72 bg-white text-black p-4 overflow-y-auto shadow-custom">
          <ul className='grid grid-cols-2 grid-rows-2 gap-4 md:block'>
            <li
              className={`mb-2 text-sm px-1 shadow-md cursor-pointer md:text-base md:px-2 py-2 rounded ${
                activeMenu === 'dashboard' ? 'bg-indigo-600 text-white' : 'hover:bg-indigo-600 hover:text-white'
              }`}
              onClick={() => navigate('/conference-registration/dashboard')}
            >
              Dashboard
            </li>
            <li
              className={`mb-2 text-sm px-1 shadow-md cursor-pointer md:text-base md:px-2 py-2 rounded ${
                activeMenu === 'register' ? 'bg-indigo-600 text-white' : 'hover:bg-indigo-600 hover:text-white'
              }`}
              onClick={() => navigate('/conference-registration/register')}
            >
            Update Profile
            </li>
            <li
    className={`mb-2 text-sm px-1 shadow-md md:text-base md:px-2 py-2 rounded ${
      authUser?.profileUpdated
        ? activeMenu === 'payment'
          ? 'bg-indigo-600 text-white'
          : 'cursor-pointer hover:bg-indigo-600 hover:text-white'
        : 'bg-gray-300 text-gray-600 cursor-not-allowed'
    }`}
    onClick={() => {
      if (authUser?.profileUpdated) {
        navigate('/conference-registration/info');
      }
    }}
  >
    Fee Payment
  </li>
  <li
    className={`mb-2 text-sm px-1 shadow-md md:text-base md:px-2 py-2 rounded ${
      authUser?.profileUpdated
        ? activeMenu === 'abstract'
          ? 'bg-indigo-600 text-white'
          : 'cursor-pointer hover:bg-indigo-600 hover:text-white'
        : 'bg-gray-300 text-gray-600 cursor-not-allowed'
    }`}
    onClick={() => {
      if (authUser?.profileUpdated) {
        navigate('/conference-registration/abstract');
      }
    }}
  >
    Abstract Submission
  </li>
          </ul>
          <div className="mt-6 hidden md:block">
            <h3 className="text-lg font-semibold px-2 py-1">Contact us</h3>
            <p className="text-sm px-2 py-1">
              Email:{' '}
              <a href="mailto:immunocon2025@mnnit.ac.in" className="text-sm">
                immunocon2025@mnnit.ac.in
              </a>
            </p>
            <p className="text-sm px-2 py-1">Mob.: +91-8543920303</p>
          </div>
        </div>

        {/* Main Content Area with Routes */}
        <div className="flex-1 p-6 bg-white shadow-inner overflow-auto">
          <Routes>
            <Route index element={<Navigate to="dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="register" element={<ConferenceRegistrationForm />} />
            <Route path='info' element={<RegistrationInfo />}/>
            <Route path="payment" element={<FeePayment />} />
            <Route path='/verify-payment' element={<VerifyPayment />} />
            <Route path="abstract" element={authUser.profileUpdated ? <AbstractSubmission /> : <Navigate to="/conference-registration/register"/>} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default ConferenceRegPage;
